// assets
import { UsergroupAddOutlined } from '@ant-design/icons';
import { DollarOutlined, StarOutlined } from '@ant-design/icons';
import CustomerIcon from 'assets/images/icons/menuSVG/customer.svg';
import BulkMessageIcon from 'assets/images/icons/menuSVG/bulk-message.svg';
import VoucherIcon from 'assets/images/icons/menuSVG/voucher.svg';
import CoinsIcon from 'assets/images/icons/menuSVG/coins.svg';
import CommonMenuIcon from 'components/commons/MenuIcon';
import { ROLE_LIST } from 'constants/index';

// icons
const icons = {
    UsergroupAddOutlined,
    DollarOutlined,
    StarOutlined
};

// ==============================|| MENU ITEMS - DASHBOARD ||============================== //

const getBuyerMenu = ({ $t, isVerified, permission }) => {
    if (permission && permission.indexOf(ROLE_LIST.CRM_VIEW) !== -1) {
        return {
            id: 'group-buyer',
            title: $t('sidebar.OpMenuGroupBuyer'),
            type: 'group',
            children: [
                {
                    id: 'buyer',
                    title: $t('buyers.OpTitle'),
                    type: 'item',
                    url: '/buyers',
                    icon: CommonMenuIcon(CustomerIcon),
                    breadcrumbs: false
                },
                {
                    id: 'reviews',
                    title: 'Reviews',
                    type: 'item',
                    url: '/reviews',
                    icon: icons.StarOutlined,
                    breadcrumbs: false
                },
                isVerified && {
                    id: 'bulk-message',
                    title: $t('bulk_message.OpTitle'),
                    type: 'item',
                    url: '/bulk-messages',
                    icon: CommonMenuIcon(BulkMessageIcon),
                    breadcrumbs: false
                },
                {
                    id: 'voucher',
                    title: $t('vouchers.OpTitle'),
                    type: 'item',
                    url: '/vouchers',
                    icon: CommonMenuIcon(VoucherIcon),
                    breadcrumbs: false
                },
                // permission.indexOf(ROLE_LIST.CRM_COIN_EDIT) !== -1 && {
                {
                    id: 'coins',
                    title: $t('coins.OpTitle'),
                    type: 'item',
                    url: '/coins',
                    icon: CommonMenuIcon(CoinsIcon),
                    breadcrumbs: false
                }
            ].filter(Boolean)
        };
    } else {
        return {};
    }
};

export default getBuyerMenu;
